import React, { useEffect, useState } from 'react';
import { useMsal } from "@azure/msal-react";

interface AuthWrapperProps {
    children: React.ReactNode;
}

const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
    
    const { instance } = useMsal();

    useEffect(() => {
        instance.handleRedirectPromise()
            .then(authResult => {
                if(authResult) {
                    const idToken = authResult.idToken;
                    const accessToken = authResult.accessToken;
                    sessionStorage.setItem('idToken', idToken);
                    sessionStorage.setItem('accessToken', accessToken);
                }
            })
            .catch(error => {
                console.error('Authentication error.' , error);
            });
    },[instance]);

    return <>{children}</>;

    
    
    
};

export default AuthWrapper;